'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _fidelitySearch = require('redux/modules/fidelitySearch');

var fidelitySearchActions = _interopRequireWildcard(_fidelitySearch);

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { push } from 'react-router-redux';

var PersonalBuyingFidelitySearch = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch(fidelitySearchActions.load(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.fidelitySearch.data,
    dataError: state.fidelitySearch.error
  };
}, (0, _extends3.default)({}, fidelitySearchActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalBuyingFidelitySearch, _Component);

  function PersonalBuyingFidelitySearch() {
    (0, _classCallCheck3.default)(this, PersonalBuyingFidelitySearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalBuyingFidelitySearch).call(this));

    _this.state = {
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(PersonalBuyingFidelitySearch, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var load = this.props.load;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      switch (clickItem) {
        case '0':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'productClassification',
            direction: currentDirection
          });
          break;
        case '1':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'popularity',
            direction: currentDirection
          });
          break;
        case '2':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'salesVolume',
            direction: currentDirection
          });
          break;
        case '3':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: 'evaluation',
            direction: currentDirection
          });
          break;
        default:
          this.setState({
            filter: '',
            orderItem: '',
            direction: ''
          });
          currentFilter = '';
          currentDirection = '';
      }
      if (load) {
        load(currentFilter, 0, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(value) {
      var load = this.props.load;
      var _state2 = this.state;
      var orderItem = _state2.orderItem;
      var direction = _state2.direction;
      var filter = _state2.filter;

      if (load) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        load(currentFilter, 0, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var load = this.props.load;
      var _state3 = this.state;
      var orderItem = _state3.orderItem;
      var direction = _state3.direction;
      var filter = _state3.filter;

      if (load) {
        this.setState({
          currentPage: page
        });
        load(filter, page, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var filterArray = [];
      // const filterArray = ['产品分类', '人气', '销量', '评价'];
      var totalPageNumber = 1;
      var artworkDiv = '';
      var errorLabel = '';
      if (data) {
        var fidelitySearch = data.fidelitySearch;
        var fidelitySearchError = data.fidelitySearchError;
        var fidelitySearchRecordCount = data.fidelitySearchRecordCount;
        var fidelitySearchPagesize = data.fidelitySearchPagesize;
        /*  const {attentionArtwork, attentionArtworkError, attentionArtworkCount, attentionArtworkPagesize} = data;
         const fidelitySearch = attentionArtwork;
         const fidelitySearchError = attentionArtworkError;
         const fidelitySearchRecordCount = attentionArtworkCount;
         const fidelitySearchPagesize = attentionArtworkPagesize;
         */

        if (fidelitySearchError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: fidelitySearchError });
        } else {
          artworkDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%', marginLeft: '42px' } },
            fidelitySearch instanceof Array ? fidelitySearch.map(function (artwork, index) {
              return _react2.default.createElement(_components.FidelitySearchComponent, { key: artwork.id, index: index, artwork: artwork });
            }) : ''
          );
          totalPageNumber = parseInt(fidelitySearchRecordCount / fidelitySearchPagesize, 10);
          if (fidelitySearchRecordCount % fidelitySearchPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.FidelitySearchPageFilterBar, { page: 'attentionArtwork', texts: filterArray, onSearch: this.onSearch.bind(this),
          onItemClick: this.onItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        artworkDiv,
        errorLabel,
        _react2.default.createElement('div', { className: 'clear' }),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return PersonalBuyingFidelitySearch;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  load: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = PersonalBuyingFidelitySearch;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalBuyingFidelitySearch/PersonalBuyingFidelitySearch.js
 ** module id = 1516
 ** module chunks = 0
 **/